import { useEffect } from "react";

import DOMPurify from "isomorphic-dompurify";

import { isValidUrl } from "../../utils/isValidUrl";

const { sanitize } = DOMPurify;
export type HtmlContainerProps = {
  htmlContent: string;
  scriptContent?: string;
  scriptUrl?: string;
};

export const HtmlContainer: React.FC<HtmlContainerProps> = (props) => {
  const { htmlContent, scriptContent } = props;

  useEffect(() => {
    if (scriptContent) {
      const head = document.head;
      const script = document.createElement("script");
      if (isValidUrl(scriptContent)) {
        script.src = scriptContent;
        script.async = true;
      } else {
        script.text = scriptContent;
      }
      head.appendChild(script);

      return () => {
        head.removeChild(script);
      };
    }
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: sanitize(htmlContent) }}></div>;
};
